<template>
  <div class="container p-2" v-if="tes_id != '' && DateStep.Step1 != ''">
    <div class="container p-2">
      <div class="alert alert-primary text-center" role="alert">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 50%"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            50%
          </div>
        </div>
        <h3 class="p-3">ขั้นตอนที่ 3</h3>
        ข้อมูลที่อยู่ของผู้สมัคร...
      </div>
      <div class="alert alert-secondary" role="alert">
        <div class="col-12 my-4 text-center">
          <h1><b>ที่อยู่ผู้สมัคร</b></h1>
          <h2 class="text-danger">
            รับสมัครปีการศึกษา {{ getDataFrom4.select_year }}
          </h2>
          <h6 class="text-danger">
            กรุณากรอกข้อมูลให้ครบทั้งหมด การสมัครเรียนแบ่งออกเป็น 5 ส่วน <br />
            <b>
              หากกรอกข้อมูลไม่ครบส่วนใดส่วนหนึ่ง
              จะถือว่าการสมัครเรียนหรือจองที่เรียนไม่สมบูรณ์</b
            ><br />
            หากไม่มีข้อมูลให้ใส่เครื่องหมาย<br />
            พบปัญหาเกี่ยวกับการกรอกข้อมูลติดต่อ 053-213061 ต่อ 112
          </h6>
        </div>
        <form @submit.prevent="SetStepStatus(5)">
          <div class="form-group">
            <div class="row">
              <div class="col-lg-12">
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ที่อยู่ตามทะเบียนบ้าน</b></h3>
                  </legend>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          บ้านเลขที่
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="บ้านเลขที่"
                        maxlength="35"
                        v-model="getDataFrom4.stu_homeid_reg"
                        required
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">หมู่บ้าน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="หมู่บ้าน"
                        maxlength="25"
                        v-model="getDataFrom4.stu_village_reg"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ซอย</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ซอย"
                        maxlength="25"
                        v-model="getDataFrom4.stu_soi_reg"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ถนน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ถนน"
                        maxlength="25"
                        v-model="getDataFrom4.stu_road_reg"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          จังหวัด
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom4.stu_province_reg"
                        @change="selectProvince()"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataProvince"
                          :key="item.pro_code"
                          :value="item.pro_code"
                        >
                          {{ item.pro_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          อำเภอ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom4.stu_district_reg"
                        @change="selectDistrict()"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataDistrict"
                          :key="item.dis_id"
                          :value="item.dis_id"
                        >
                          {{ item.dis_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ตำบล
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom4.stu_loality_reg"
                        @change="loadPostCode('postcode_reg')"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataLocality"
                          :key="item.loc_id"
                          :value="item.loc_id"
                        >
                          {{ item.loc_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          รหัสไปรษณีย์
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="รหัสไปรษณีย์"
                        maxlength="5"
                        inputmode="numeric"
                        v-model="getDataFrom4.stu_postcode_reg"
                        required
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">เบอร์โทรศัพท์ผู้สมัคร</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="เบอร์โทรศัพท์"
                        maxlength="10"
                        minlength="10"
                        inputmode="numeric"
                        v-model="getDataFrom4.stu_phone_reg"
                      />
                    </div>
                    <div class="col-lg-5 my-3"></div>
                  </div>
                </fieldset>
              </div>
              <div class="col-lg-12">
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ที่อยู่ปัจจุบัน</b></h3>
                  </legend>
                  <div class="form-group">
                    <div class="mb-5">
                      <div>
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          v-model="selected"
                          @change="select()"
                          id="choose_home"
                        />
                        <label for="choose_home" class="user-select-none">ที่อยู่ตามทะเบียนบ้าน</label>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          บ้านเลขที่
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="บ้านเลขที่"
                        maxlength="35"
                        v-model="getDataFrom4.stu_homeid"
                        required
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">หมู่บ้าน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="หมู่บ้าน"
                        maxlength="25"
                        v-model="getDataFrom4.stu_village"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ซอย</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ซอย"
                        maxlength="25"
                        v-model="getDataFrom4.stu_soi"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ถนน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ถนน"
                        maxlength="25"
                        v-model="getDataFrom4.stu_road"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          จังหวัด
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom4.stu_province"
                        @change="selectProvinceD()"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataProvince"
                          :key="item.pro_code"
                          :value="item.pro_code"
                        >
                          {{ item.pro_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          อำเภอ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom4.stu_district"
                        @change="selectDistrictD()"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataDistrictD"
                          :key="item.dis_id"
                          :value="item.dis_id"
                        >
                          {{ item.dis_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ตำบล
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom4.stu_locality"
                        @change="loadPostCode('postcode')"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataLocalityD"
                          :key="item.loc_id"
                          :value="item.loc_id"
                        >
                          {{ item.loc_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          รหัสไปรษณีย์
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="รหัสไปรษณีย์"
                        maxlength="5"
                        inputmode="numeric"
                        v-model="getDataFrom4.stu_postcode"
                        required
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">เบอร์โทรศัพท์ผู้สมัคร</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="เบอร์โทรศัพท์"
                        maxlength="10"
                        minlength="10"
                        inputmode="numeric"
                        v-model="getDataFrom4.stu_phone"
                      />
                    </div>
                    <div class="col-lg-5 my-3"></div>
                  </div>
                </fieldset>
              </div>
            </div>
            <!-- {{ this.getDataFrom4 }} -->
          </div>
          <div class="form-group">
            <div class="row">
              <div
                class="col"
                v-if="getqrcodeChkStatusPay.status != 'Paysuccess'"
              >
                <div class="d-inline-flex p-2" style="float: left">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="SetStepStatus(3)"
                  >
                    <font-awesome-icon :icon="['fas', 'backward']" /> ย้อนกลับ
                  </button>
                </div>
                <div class="d-inline-flex p-2" style="float: right">
                  <button type="submit" class="btn btn-primary">
                    ถัดไป <font-awesome-icon :icon="['fas', 'forward']" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
  data() {
    return { selected: false };
  },
  async mounted() {
    if (this.tes_id != "" && this.DateStep.Step1 != "") {
      // get Data Step2
    } else {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาดำเนินการขั้นตอน Login ก่อน...",
      });
      this.$store.dispatch("Main/SetStepStatus", 1);
      return;
    }

    if (this.DateStep.Step2 == "") {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาบันทึกข้อมูลในขั้นตอนที่ 1 ก่อน...",
      });
      await this.$store.dispatch("Main/SET_Onload", true);
      this.$store.dispatch("Main/SetStepStatus", 2);
      return;
    }
    this.$store.dispatch("Main/SET_Onload", false);
    await this.$store.dispatch("Step4/SetStep4");
    this.$store.dispatch("Step4/GET_DataProvince");
    this.$store.dispatch("Step4/POST_DataDistrict");
    this.$store.dispatch("Step4/POST_DataDistrictD");
    this.$store.dispatch("Step4/POST_DataLocality");
    this.$store.dispatch("Step4/POST_DataLocalityD");

    $(document).ready(function () {
      $(".IsNumber").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if (
          $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode == 65 && e.ctrlKey === true) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)
        ) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if (
          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
          (e.keyCode < 96 || e.keyCode > 105)
        ) {
          e.preventDefault();
        }
      });
    });

    this.scrollToTop();
  },
  methods: {
    async loadPostCode(name) {
      if (name == "postcode_reg") {
        for (const item of this.getDataLocality) {
          if (item.loc_id == this.getDataFrom4.stu_loality_reg) {
            this.getDataFrom4.stu_postcode_reg = item.post_code;
            break;
          } else {
            this.getDataFrom4.stu_postcode_reg = "";
          }
        }
      } else if (name == "postcode") {
        for (const item of this.getDataLocalityD) {
          if (item.loc_id == this.getDataFrom4.stu_locality) {
            this.getDataFrom4.stu_postcode = item.post_code;
            break;
          } else {
            this.getDataFrom4.stu_postcode = "";
          }
        }
      }
    },
    async select() {
      if (this.selected == true) {
        this.$store.dispatch("Step4/POST_DataDistrictRegistration");
        this.$store.dispatch("Step4/POST_DataLocalityRegistration");

        this.getDataFrom4.stu_homeid = this.getDataFrom4.stu_homeid_reg;
        this.getDataFrom4.stu_village = this.getDataFrom4.stu_village_reg;
        this.getDataFrom4.stu_soi = this.getDataFrom4.stu_soi_reg;
        this.getDataFrom4.stu_road = this.getDataFrom4.stu_road_reg;
        this.getDataFrom4.stu_locality = this.getDataFrom4.stu_loality_reg;
        this.getDataFrom4.stu_district = this.getDataFrom4.stu_district_reg;
        this.getDataFrom4.stu_province = this.getDataFrom4.stu_province_reg;
        this.getDataFrom4.stu_postcode = this.getDataFrom4.stu_postcode_reg;
        this.getDataFrom4.stu_phone = this.getDataFrom4.stu_phone_reg;
      } else {
        this.getDataFrom4.stu_homeid = "";
        this.getDataFrom4.stu_village = "";
        this.getDataFrom4.stu_soi = "";
        this.getDataFrom4.stu_road = "";
        this.getDataFrom4.stu_locality = "";
        this.getDataFrom4.stu_district = "";
        this.getDataFrom4.stu_province = "";
        this.getDataFrom4.stu_postcode = "";
        this.getDataFrom4.stu_phone = "";
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เพื่อให้การเลื่อนเป็นแบบนุ่มนวล
      });
    },
    async SetStepStatus(payload) {
      await this.$store.dispatch("Main/SET_Onload", true);
      this.getDataFrom4.tes_id = this.tes_id;
      await this.$store.dispatch("Step4/SetStepStatus");
      if (this.DateStep4.status == true) {
        await this.$swal({
          icon: this.DateStep4.type,
          title: this.DateStep4.alert,
          text: this.DateStep4.text,
        });
        this.$store.dispatch("Main/SetStepStatus", payload);
      } else if (this.DateStep4.status == false) {
        await this.$swal({
          icon: this.DateStep4.type,
          title: this.DateStep4.alert,
          html: `${this.DateStep4.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
        });
      }
    },
    async selectProvince() {
      this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step4/POST_DataDistrict");
      await this.$store.dispatch("Step4/POST_DataLocality");
      this.loadPostCode("postcode_reg");
    },
    async selectProvinceD() {
      this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step4/POST_DataDistrictD");
      await this.$store.dispatch("Step4/POST_DataLocalityD");
      this.loadPostCode("postcode");
    },
    async selectDistrict() {
      await this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step4/POST_DataLocality");
      this.loadPostCode("postcode_reg");
    },
    async selectDistrictD() {
      await this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step4/POST_DataLocalityD");
      this.loadPostCode("postcode");
    },
  },
  computed: {
    ...mapGetters({
      tes_id: "Main/_getTesID",
      DateStep: "Main/_getDateStep",
      DateStep4: "Main/_getDateStep4",
      getDataFrom4: "Step4/_getDataFrom4",
      getDataProvince: "Step4/_getDataProvince",
      getDataDistrict: "Step4/_getDataDistrict",
      getDataDistrictD: "Step4/_getDataDistrictD",
      getDataLocality: "Step4/_getDataLocality",
      getDataLocalityD: "Step4/_getDataLocalityD",
      getSetStep4: "step4/_SetStep4",
      getqrcodeChkStatusPay: "Step6/_getqrcodeChkStatusPay",
    }),
  },
};
</script>

<style></style>
